import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { InspectWizard } from './pages/InspectWizard';
import { Inspections } from './pages/Inspections';
import { InspectionDetail } from './pages/InspectionDetail';
import { HowItWorks } from './pages/HowItWorks';
import { Tips } from './pages/Tips';
import { API } from './pages/API';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Project } from './pages/Project';

/**
 * The /project route is an internal dashboard — it owns its full-width chrome,
 * so it shouldn't render inside the public-site Layout wrapper.
 */
function AppShell() {
  const location = useLocation();
  const isProject = location.pathname.startsWith('/project');

  const routes = (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/tips" element={<Tips />} />
      <Route path="/inspect" element={<InspectWizard />} />
      <Route path="/inspections" element={<Inspections />} />
      <Route path="/inspections/:id" element={<InspectionDetail />} />
      <Route path="/api" element={<API />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/project" element={<Project />} />
    </Routes>
  );

  return isProject ? routes : <Layout>{routes}</Layout>;
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
